import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback, memo } from "react";
import { fieldToTextField as fieldToMuiTextField } from "formik-material-ui";
import { DployTextField } from "./DployTextField";
import { InputAdornment } from "@material-ui/core";
import { identityRecordOfFieldEditorOptions, getFieldError } from "./utils";
const MemoDploytextField = memo(DployTextField);
export const useFieldToTextField = ({ fieldName, items, getItemLabel, getItemValue, valueKey, labelKey, getItemSuggestions, onSelectItem, manual, horizontal: row, multiple, pending, suffix, prefix, emptyEqualsZero, options, formatString, searchable, minSearch, italicText, boldText, modalText, onBlur: propsBlur, errorDisplay, clearable, textAreaRows, maxLength, ...props }) => {
    const { field, form: { errors, touched } } = props;
    const InputProps = useMemo(() => ({
        startAdornment: prefix ? (_jsx(InputAdornment, { position: "start", children: prefix })) : (props.InputProps && props.InputProps.startAdornment),
        endAdornment: suffix ? (_jsx(InputAdornment, { position: "end", children: suffix })) : (props.InputProps && props.InputProps.endAdornment),
        ...props.InputProps
    }), [prefix, props.InputProps, suffix]);
    var textFieldProps = fieldToMuiTextField(props);
    const { onBlur: formikBlur } = textFieldProps;
    const onBlur = useCallback((e) => {
        if (formikBlur)
            formikBlur(e);
        if (propsBlur)
            propsBlur(e);
    }, [formikBlur, propsBlur]);
    return {
        fieldName,
        ...textFieldProps,
        ...getFieldError(errors, touched, field.name, errorDisplay),
        onBlur,
        InputProps
    };
};
export const TextField = props => (_jsx(MemoDploytextField, { ...useFieldToTextField(props) }));
export const UppercaseTextField = props => {
    const { form: { setFieldValue }, field: { name } } = props;
    const { onChange: textFieldOnChange, ...textfieldProps } = useFieldToTextField(props);
    const onChange = useCallback(event => {
        if (textFieldOnChange)
            textFieldOnChange(event);
        const { value } = event.target;
        setFieldValue(name, value ? value.toUpperCase() : "");
    }, [textFieldOnChange, setFieldValue, name]);
    return _jsx(MemoDploytextField, { ...textfieldProps, onChange: onChange });
};
export const TextArea = props => {
    const rows = props.textAreaRows
        ? props.textAreaRows
        : props.options?.textAreaRows
            ? props.options.textAreaRows
            : 10;
    return (_jsx(MemoDploytextField, { ...useFieldToTextField(props), multiline: true, rows: rows, maxLength: props.options?.maxLength }));
};
const commonEditorProps = {
    editableOptions: {
        placeholder: true,
        suffix: true
    }
};
const textAreaEditorProps = {
    editableOptions: {
        placeholder: true,
        textAreaRows: true,
        maxLength: true
    }
};
export const EditorTextFields = identityRecordOfFieldEditorOptions({
    TextField: commonEditorProps,
    UppercaseTextField: commonEditorProps,
    TextArea: textAreaEditorProps
});
//# sourceMappingURL=TextFields.js.map